import React from 'react'

import Link from 'next/link'

export function Support() {
  return (
    <div className='flex flex-col gap-5 p-5'>
      <Link
        href={process.env.NEXT_PUBLIC_MAX_RELEASE_NOTES}
        passHref
        target='_blank'
        rel='noopener noreferrer'
        className='btn'
      >
        View Release Notes
      </Link>
      <Link
        href='/issues'
        passHref
        target='_blank'
        rel='noopener noreferrer'
        className='btn btn-primary'
      >
        Submit a MAX ticket
      </Link>
    </div>
  )
}
